/** Pastel backgrounds with matching dark text; the same name always gets the same colour. */
const PALETTE = [
  "bg-[#e8def8] text-[#3b2a6b]",
  "bg-[#d3e3fd] text-[#0b3a82]",
  "bg-[#c4eed0] text-[#0f5223]",
  "bg-[#ffdad6] text-[#7a1d14]",
  "bg-[#ffe08a] text-[#5c4300]",
  "bg-[#d5ecea] text-[#0a4b49]",
  "bg-[#f8d8e6] text-[#6b1e43]",
  "bg-[#e3e3e3] text-[#303030]",
] as const;

function hash(text: string): number {
  let h = 0;
  for (const char of text) h = (h * 31 + (char.codePointAt(0) ?? 0)) >>> 0;
  return h;
}

/** First letter of the name, or of the address when there is no name. */
export function initialOf(name: string): string {
  const letter = name.trim().replace(/^["'<(]+/, "")[0] ?? "?";
  return letter.toLocaleUpperCase();
}

export function Avatar({
  name,
  size = 40,
  className = "",
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  const colour = PALETTE[hash(name.toLowerCase()) % PALETTE.length];
  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 select-none items-center justify-center rounded-full font-medium ${colour} ${className}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
    >
      {initialOf(name)}
    </span>
  );
}
